import { colors } from '../constants/colors.js';
var npsThemeWeb = {
  color: 'primary',
  background: 'background',
  closeButtonBackground: 'background',
  textColors: {
    /**
     * Text color for labels: minScore and maxScore
     */
    scoreMinMax: colors.octoberGrey,

    /**
     * Text color for the descriptions: npsDescription and feedbackDescription
     */
    description: 'text',

    /**
     * Text color for the heading
     */
    heading: 'text'
  }
};
export { npsThemeWeb };